// Shared, read-only resolution of internal-staff client assignments from client_role_assignments.
// The editable source is the Utilities → Table Management → Client Assignments grid; everything else READS
// via these helpers so all displays resolve identically. See migration 2026-07-08_client_role_assignments.sql.
//
// Linkage note: client_role_assignments.client_id, properties.client_id and parcels.client_id are all the
// client SLUG (clients.id, e.g. "cbre-investment-management"). Resolve a caller's client by that id.
// ⛔ parcels ALSO carry a denormalised client_name (the display name) — do not key assignments off it: it is
// null on every parcel the app creates, and matching on a display name breaks the moment a client is renamed.

export const rolesForClient = (assignments, clientId, role) =>
  (assignments || []).filter(a => a.client_id === clientId && a.role === role);

export const staffNameFrom = (staff, id) => ((staff || []).find(x => x.id === id) || {}).name || '';

// Comma-joined staff names for a client's role (CM/CS). Empty string when none.
export const roleNames = (assignments, staff, clientId, role) =>
  rolesForClient(assignments, clientId, role).map(r => staffNameFrom(staff, r.staff_id)).filter(Boolean).join(', ');

// TS rows that apply to a specific parcel: a parcel-level override (parcels.ts_id) wins; otherwise the client's
// role='TS' rows whose all_states=true OR whose states[] contains the parcel's state. Returns row-shaped objects
// ({ staff_id, all_states, states }) so TsAssignmentDisplay can render the split + hover-bubble.
export function tsRowsForParcel(assignments, clientId, parcel) {
  if (parcel && parcel.ts_id) return [{ staff_id: parcel.ts_id, all_states: true, states: null }];
  const st = parcel && parcel.state;
  return rolesForClient(assignments, clientId, 'TS').filter(r => r.all_states || (st && (r.states || []).includes(st)));
}

// Plain-text TS summary for a client (all TS rows), split rows suffixed with their states. For CSV / sort / filter.
export const tsText = (assignments, staff, clientId) =>
  rolesForClient(assignments, clientId, 'TS')
    .map(r => `${staffNameFrom(staff, r.staff_id)}${r.all_states ? '' : ` (${(r.states || []).join('/')})`}`)
    .filter(Boolean).join(', ');
